export default `{
  "pageOrientation": "portrait",
  "pageSize": "A4",
  "pageMargins": [
    10,
    5,
    10,
    5
  ],
  "content": [
    {
      "image": "hospitalLogo",
      "width": 45,
      "alignment": "left",
      "absolutePosition": {
        "x": 10,
        "y": 24
      }
    },
    {
      "image": "protocolLogo",
      "width": 25,
      "alignment": "right",
      "absolutePosition": {
        "x": 0,
        "y": 20
      },
      "margins": [
        0,
        0,
        30,
        0
      ]
    },
    {
      "text": "Autorização de Materiais",
      "style": "header"
    },
    {
      "style": "table",
      "table": {
        "widths": [
          "50%",
          "25%",
          "25%"
        ],
        "headerRows": 2,
        "body": [
          [
            {
              "text": "Paciente",
              "style": "tableHeader2",
              "colSpan": 3,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ],
              "fillColor": "#f0f0f0"
            },
            {},
            {
              "text": "",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ],
          [
            {
              "text": "Nome",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "Idade",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "CPF",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ],
          [
            {
              "text": "{{ paciente.nome }}",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{ paciente.idade }}",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{ paciente.documento }}",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ]
        ]
      }
    },
    {
      "style": "table",
      "table": {
        "widths": [
          "50%",
          "25%",
          "25%"
        ],
        "headerRows": 2,
        "body": [
          [
            {
              "text": "Convênio",
              "style": "tableHeader2",
              "colSpan": 3,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ],
              "fillColor": "#f0f0f0"
            },
            {},
            {
              "text": "",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ],
          [
            {
              "text": "Convênio",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "Plano",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "Categoria",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ],
          [
            {
              "text": "{{ convenio.nome }}",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{ convenio.plano }}",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{ convenio.categoria }}",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ],
          [
            {
              "text": "Cód. Assoc.",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "Senha",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ],
          [
            {
              "text": "{{ convenio.codigoAssociado }}",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{ convenio.senha }}",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ]
        ]
      }
    },
    {
      "style": "table",
      "table": {
        "widths": [
          "50%",
          "25%",
          "25%"
        ],
        "headerRows": 2,
        "body": [
          [
            {
              "text": "Cirurgia",
              "style": "tableHeader2",
              "colSpan": 3,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ],
              "fillColor": "#f0f0f0"
            },
            {},
            {
              "text": "",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ],
          [
            {
              "text": "Procedimento Principal",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "Protocolo / Pacote",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "Data da Cirugia",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ],
          [
            {
              "text": "{{ cirurgia.procedimentoPrincipal }}",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{ cirurgia.segueOProtocolo }}",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{{ cirurgia.dataAgendamento }}}",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ],
          [
            {
              "text": "Médico",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "Registro",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "Contato",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ],
          [
            {
              "text": "{{ cirurgia.medico.nome }}",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{ cirurgia.medico.registro }}",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{ cirurgia.medico.contato }}",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ]
        ]
      }
    },
    {
      "style": "table",
      "table": {
        "widths": [
          "*",
          80,
          40,
          60,
          60
        ],
        "headerRows": 2,
        "body": [
          [
            {
              "text": "  Materiais Solicitados  ",
              "style": "tableHeader2",
              "colSpan": 5,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ],
              "fillColor": "#f0f0f0"
            },
            {},
            {},
            {},
            {}
          ],
          [
            {
              "text": "Material",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "Fabricante",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "Qtd",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "HIS Compra",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "HIS Consig.",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ] {{#temMateriais}},{{/temMateriais}}

          {{#materiais}}
          [
            {
              "text": "{{{nome}}}",
              "style": "{{{rowStyle}}}",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{{fabricante}}}",
              "style": "{{{rowStyle}}}",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{{quantidade}}}",
              "style": "{{{rowStyle}}}",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{{hisCompra}}}",
              "style": "{{{rowStyle}}}",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{{hisConsignado}}}",
              "style": "{{{rowStyle}}}",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ] {{^lastItem}},{{/lastItem}}
          {{/materiais}}

        ]
      }
    },
    {
      "style": "table",
      "table": {
        "widths": [
          "*",
          80,
          40,
          60,
          60
        ],
        "headerRows": 2,
        "body": [
          [
            {
              "text": "Materiais Adicionais",
              "style": "tableHeader2",
              "colSpan": 5,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ],
              "fillColor": "#f0f0f0"
            },
            {},
            {},
            {},
            {}
          ],
          [
            {
              "text": "Material",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "Fabricante",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "Qtd",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "HIS Compra",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "HIS Consig.",
              "style": "tableHeader",
              "colSpan": 1,
              "alignment": "left",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ] {{#temMateriaisAdicionais}},{{/temMateriaisAdicionais}}

          {{#materiaisAdicionais}}
          [
            {
              "text": "{{{nome}}}",
              "style": "{{{rowStyle}}}",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{{fabricante}}}",
              "style": "{{{rowStyle}}}",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{{quantidade}}}",
              "style": "{{{rowStyle}}}",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{{hisCompra}}}",
              "style": "{{{rowStyle}}}",
              "border": [
                0,
                0,
                0,
                0
              ]
            },
            {
              "text": "{{{hisConsignado}}}",
              "style": "{{{rowStyle}}}",
              "border": [
                0,
                0,
                0,
                0
              ]
            }
          ] {{^lastItem}},{{/lastItem}}
          {{/materiaisAdicionais}}

        ]
      }
    }
  ],
  "images": {
    "hospitalLogo": "{{{ hospitalLogo }}}",
    "protocolLogo": "{{{ protocolLogo }}}",
    "protocolGrayScaleLogo": "{{{ protocolGrayScaleLogo }}}"
  },
  "styles": {
    "header": {
      "fontSize": 18,
      "bold": false,
      "alignment": "center",
      "margin": [
        0,
        20,
        0,
        20
      ]
    },
    "subheader": {
      "fontSize": 16,
      "bold": true,
      "margin": [
        0,
        10,
        0,
        5
      ]
    },
    "table": {
      "margin": [
        0,
        0,
        0,
        15
      ],
      "fontSize": 10
    },
    "tableHeader": {
      "margin": [
        0,
        10,
        0,
        0
      ],
      "bold": true,
      "color": "black"
    },
    "tableHeader2": {
      "bold": true,
      "color": "black",
      "fontSize": 12
    },
    "rowEven": {
      "fillColor": "#f0f0f0"
    },
    "rowOdd": {
      "fillColor": ""
    }
  }
}`
